/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/cocktaildamore/"

const COCKTAILDAMORE: CommunityData = {
  code: "cocktaildamore",
  inviteCode: "cocktaildamore",
  name: "Cocktail D'Amore",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/cda-030`,
  waitlist: true,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#ffecfc",
      hero: {
        desktop: `${S3_PREFIX}web-background-non-member.jpg`,
        mobile: `${S3_PREFIX}web-background-non-member.jpg`,
        style: "bg-cover bg-center",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[214px]",
      },
      werzLogoColor: "#191818",
      title:
        "font-['HelveticaNowDisplayExtraBlack'] text-[26px] leading-[110%] uppercase text-[#000000]",
      text: "font-['DINAlternateBold'] text-[15px] leading-[120%] text-[#222222]",
      button:
        "font-['HelveticaNowDisplayExtraBlack'] text-[16px] leading-[100%] uppercase px-[18px] py-[18px] border-2 border-[#000000] bg-[#000000] text-[#ffffff] cursor-pointer w-fit",
      input: {
        base: "font-['DINAlternateBold'] text-[15px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#ffffff] text-[#000000]",
        border: "#000000",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['DINAlternateBold'] text-[13px] leading-[120%] text-[#FF0000]",
      footerText: "font-['DINAlternateBold'] text-[13px] leading-[120%] text-[#222222]",
      skipButton:
        "font-['DINAlternateBold'] text-[13px] leading-[120%] text-[#222222] cursor-pointer",
      modal: {
        container: "bg-[#ffecfc] border-2 border-[#000000] px-[40px] py-[48px]",
        title:
          "font-['HelveticaNowDisplayExtraBlack'] text-[26px] leading-[110%] uppercase text-[#000000] text-center",
        text: "font-['DINAlternateBold'] text-[15px] leading-[120%] text-[#222222] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] text-[#000000] bg-[#ffffff] font-['HelveticaNowDisplayExtraBlack'] text-[16px] leading-[100%] text-center",
        otpBorder: "#000000",
        otpBorderFocus: "#000000",
      },
    },
    global: {
      counterColor: "#000000",
      logo: {
        src: "https://media.werz.at/community/icon/cmoaehyes00009kg2v7jxvdi4.jpg?uploadTime=1777536063740&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[214px] h-[38.70212936401367px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ffecfc",
      asideBg: "#ffffff",
      asideStyles: "border-r-2 border-[#000000] !p-0 !gap-0",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['DINAlternateBold']",
      primaryButton:
        "bg-[#000000] border-2 border-[#000000] px-[18px] py-[18px] !text-[#ffffff] font-['HelveticaNowDisplayExtraBlack'] !text-[16px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-2 border-[#000000]",
      separator: "border-[#000000]",
      item: "font-['HelveticaNowDisplayExtraBlack'] text-[16px] text-[#000000] uppercase text-center leading-[100%] gap-x-[10px] text-opacity-50 border-b-2 border-[#000000] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ffecfc] border-2 border-[#000000] !pb-8",
      titles:
        "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#222222] font-['DINAlternateBold'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b-2 border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden !bg-[#ffecfc]",
          mediaContainer: "w-full sm:w-[256px] !h-[256px] relative",
          media: "w-full !h-[256px] object-cover border-2 border-[#000000]",
          placeholderMedia: "w-full !h-[256px] bg-gray-400 border-2 border-[#000000]",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#222222] font-['DINAlternateBold'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b-2 border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden !bg-[#ffecfc]",
          mediaContainer: "w-full sm:!w-[228px] sm:!h-[128px] !h-[180px] sm:flex-shrink-0 relative",
          media:
            "w-full sm:!w-[228px] sm:!h-[128px] !h-[180px] object-cover border-2 border-[#000000]",
          placeholderMedia:
            "w-full sm:!w-[228px] sm:!h-[128px] !h-[180px] bg-gray-400 border-2 border-[#000000]",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#222222] font-['DINAlternateBold'] text-[13px] text-left leading-[120%] mt-2",
          location:
            "text-[#222222] font-['DINAlternateBold'] text-[13px] text-left leading-[120%] mt-1",
          date: "text-[#222222] font-['DINAlternateBold'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['DINAlternateBold'] text-[17px] text-left leading-[120%]",
        customShopImageStyle: "border-2 border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-non-member.jpg`,
      bgMobile: `${S3_PREFIX}mobile-landing-background.jpg`,
      bgMedia: "object-cover object-[center_top]",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#ffecfc] px-4 py-12 sm:p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#000000] object-cover",
        name: "text-[#ffffff] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-center leading-[110%] mt-4 mb-1",
        location:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase text-center leading-[110%] mb-2",
        description:
          "text-[#000000] font-['DINAlternateBold'] text-[17px] text-center leading-[120%] mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#ffffff] border-2 border-[#000000] px-[12px] py-[12px] text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] bg-[#ffecfc] text-[#000000] font-['DINAlternateBold'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border-2 border-[#000000]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] bg-[#ffecfc] border-2 border-[#000000] flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title:
            "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase text-center leading-[110%] mb-1",
          text: "text-[#000000] font-['DINAlternateBold'] text-[17px] text-center leading-[120%]",
          button:
            "bg-[#ffffff] border-2 border-[#000000] px-[12px] py-[12px] text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] bg-[#ffecfc] border-2 border-[#000000] flex justify-between",
          duration: "text-[#222222] font-['DINAlternateBold'] text-[13px] text-left leading-[120%]",
          name: "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "border-2 border-[#000000] overflow-hidden m-2",
        },
        event: {
          container: "bg-[#ffecfc] border-2 border-[#000000] overflow-hidden sm:w-[500px] w-[95vw]",
          name: "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase text-left leading-[110%] mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] bg-[#000000] border border-[#000000] text-[#ffffff] flex flex-col justify-center items-center gap-1 font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase",
          duration: "text-[#222222] font-['DINAlternateBold'] text-[13px] text-left leading-[120%]",
          location: "text-[#222222] font-['DINAlternateBold'] text-[13px] text-left leading-[120%]",
          button:
            "bg-[#ffffff] border-2 border-[#000000] px-[12px] py-[12px] text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] border-t-2 border-[#000000] px-4 py-3 flex justify-between gap-4",
            name: "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#222222] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[110%]",
            link: "text-[#222222] font-['DINAlternateBold'] text-[13px] text-left leading-[120%]",
            status:
              "text-[#222222] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[110%]",
            button:
              "bg-[#ffffff] border-2 border-[#000000] px-[12px] py-[12px] text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[100%] !w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['DINAlternateBold'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] bg-[#ffecfc] text-[#000000] font-['DINAlternateBold'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border-2 border-[#000000]",
        header:
          "text-[#ffffff] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#ffecfc] sm:w-[500px] w-[95vw] border-2 border-[#000000] flex justify-between",
          name: "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#222222] font-['DINAlternateBold'] text-[15px] text-left leading-[120%]",
          media: "border-2 border-[#000000] overflow-hidden m-2",
        },
        seeAllNews:
          "text-[#000000] font-['DINAlternateBold'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] bg-[#ffecfc] text-[#000000] font-['DINAlternateBold'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border-2 border-[#000000]",
        header:
          "text-[#ffffff] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer bg-[#ffecfc] sm:w-[500px] w-[95vw] border-2 border-[#000000] flex justify-between",
          coverUrl: "border-2 border-[#000000] overflow-hidden m-2",
          duration: "text-[#222222] font-['DINAlternateBold'] text-[15px] text-left leading-[120%]",
          liveType: "text-[#222222] font-['DINAlternateBold'] text-[15px] text-left leading-[120%]",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#ffecfc",
          playIconBackgroundColor: "#000000",
          playIconBorderColor: "#ffecfc",
          start: "text-[#222222] font-['DINAlternateBold'] text-[15px] text-left leading-[120%]",
          title:
            "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['DINAlternateBold'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] bg-[#ffecfc] text-[#000000] font-['DINAlternateBold'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border-2 border-[#000000]",
        header:
          "text-[#ffffff] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#ffecfc] w-[95vw] border-2 border-[#000000] flex justify-between",
          name: "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[16px] uppercase leading-[110%]",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border-2 border-[#000000] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#000000] font-['DINAlternateBold'] text-[13px] text-center leading-[120%]",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffecfc] border-2 border-[#000000] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b-2 border-[#000000]",
        media:
          "sm:!w-[320px] sm:!h-[180px] !w-full !h-[180px] object-cover sm:mb-4 border-2 border-[#000000]",
        title:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#222222] font-['DINAlternateBold'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#000000] border-2 border-[#000000] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['HelveticaNowDisplayExtraBlack'] !text-[16px] uppercase text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b-2 border-[#000000]",
        header:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['DINAlternateBold'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b-2 border-[#000000]",
        header:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['DINAlternateBold'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] border-2 border-[#000000]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['DINAlternateBold'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[22px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffecfc] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border-2 border-[#000000] px-[12px] py-[12px] text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffecfc] border-b-2 border-[#000000] py-2 sm:py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#222222] font-['DINAlternateBold'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#222222] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[100%]",
          status:
            "text-[#222222] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff] border-2 border-[#000000] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff] border-2 border-[#000000] px-[12px] py-[12px] text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[14px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default COCKTAILDAMORE
